import { flagFactory } from '../icon';
import Svg from './de.svg';

export default flagFactory(Svg);
